import { render, staticRenderFns } from "./CategoriesListItem.vue?vue&type=template&id=c3fc3d1c&scoped=true&"
import script from "./CategoriesListItem.vue?vue&type=script&lang=js&"
export * from "./CategoriesListItem.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesListItem.vue?vue&type=style&index=0&id=c3fc3d1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3fc3d1c",
  null
  
)

export default component.exports